'use strict'

import autosize from 'autosize'

export default class TextareaAutosize {
  constructor (element) {
    autosize(element)
  }
}
